function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FaArrowRight } from 'react-icons/fa6';
var AzureBlob = function AzureBlob(_ref) {
  var filename = _ref.filename,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$assetID = _ref.assetID,
    assetID = _ref$assetID === void 0 ? null : _ref$assetID,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var navigate = useNavigate();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    count = _useState4[0],
    setCount = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  useEffect(function () {
    setLoading(true);
    setCount(0);
    setError(false);
  }, [filename]);
  useEffect(function () {
    loadImage();
  }, [loading]);
  useEffect(function () {
    if (count === 10) setError(true);else {
      setTimeout(function () {
        loadImage();
      }, 1000 + count * 1000);
    }
  }, [count]);
  var loadImage = function loadImage() {
    var img = new window.Image();
    img.onload = function () {
      setLoading(false);
    };
    img.onerror = function () {
      setCount(count + 1);
    };
    img.src = "".concat(bucket, "/").concat(filename);
  };
  if (loading) return /*#__PURE__*/React.createElement("div", {
    className: "azure-blob"
  }, error ? 'Could not load asset...' : 'Loading...');
  return /*#__PURE__*/React.createElement("div", {
    className: "azure-blob ".concat(className),
    style: style,
    onClick: function onClick() {
      if (assetID) navigate("/asset/".concat(assetID));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "azure-blob__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(bucket, "/").concat(filename)
  })), assetID && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h1", null, "View Asset"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FaArrowRight, null))));
};
export default AzureBlob;